import { Injectable } from '@angular/core';
import { AppVersionInitializer } from '@/app/initializers/app-version.initializer';
import { CurrentTabInitializer } from '@/app/initializers/current-tab.initializer';
import { LanguageInitializer } from '@/app/initializers/language.initializer';
import { PlatformInitializer } from '@/app/platform/platform-core/platform-initializer';
import { SupportPanelService } from '@/app/support/support-panel.service';
import { AppUpdateService } from '@core/app-update/app-update.service';
import { currentTab } from '@/app/current-tab';
import { StartupWarmupService } from '@/app/initializers/startup-warmup.service';

@Injectable({
  providedIn: 'root'
})
export class AppGlobalInitializer {
  constructor(
    private readonly appVersionInitializer: AppVersionInitializer,
    private readonly currentTabInitializer: CurrentTabInitializer,
    private readonly languageInitializer: LanguageInitializer,
    private readonly platformInitializer: PlatformInitializer,
    private readonly supportPanelService: SupportPanelService,
    private readonly appUpdateService: AppUpdateService,
    private readonly startupWarmup: StartupWarmupService
  ) {}

  async init() {
    const consequence = this.appVersionInitializer.init();
    if (consequence === 'reload') {
      return;
    }

    // Vóór de user-load en de eerste routing: een login-redirect mag de support-deep-link niet kwijtraken.
    this.supportPanelService.stashDeepLink();
    this.currentTabInitializer.init();
    this.languageInitializer.init();
    // Na de taal-init (laadt de vertalingen van de actieve taal), parallel met de platform-init.
    const warmup = this.startupWarmup.start();
    // Vóór de platform-init: die start de SignalR-hub, en elke (her)verbinding vraagt een update-check.
    this.appUpdateService.start();

    await this.platformInitializer.init();

    // Ingelogd: het opstartscherm blijft staan tot fonts, vertalingen en de bodygraph binnen zijn
    // (hoogstens STARTUP_WARMUP_MAX_WAIT_MS na de start), zodat het eerste scherm meteen compleet
    // is. Niet ingelogd: het loginscherm wacht niet; de warm-up loopt op de achtergrond door terwijl
    // de gebruiker inlogt, zodat de app na het inloggen (zelfde tab, geen herlaad) al klaarstaat.
    if (currentTab.getAuth()) {
      await warmup;
    }
  }
}
